module.exports = __webpack_public_path__ + "static/media/6.a6b885a3.gif";